import * as d3 from "d3";

import { createPlotConfig } from "../../types";
import { drawConnectionLines } from "./drawConnectionLines";
import {
  pointOpacityByClass,
  pointRadiusByClass,
  pointStrokeWidthByClass,
} from "../drawPlotData/utils/drawCircles";

export const unselectSwarmBoxSubject = (
  plotClassName: string,
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
  config: createPlotConfig,
) => {
  const svg = d3.select(`.plot-container.${plotClassName}`);
  svg
    .selectAll("circle")
    .classed("muted", false)
    .classed("clicked", false)
    .attr("fill", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-fill");
    })

    .attr("stroke", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-stroke");
    })
    .style("opacity", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-opacity");
    })
    .attr("r", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-radius");
    });

  svg.selectAll(".connection-line").remove();
};

export const selectSwarmBoxSubject = (
  plotClassName: string,
  ssjIdValue: string,
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
  config: createPlotConfig,
) => {
  const svg = d3.select(`.plot-container.${plotClassName}`);

  svg.selectAll(".connection-line").remove();

  svg
    .selectAll(".clicked")
    .classed("clicked", false)
    .attr("fill", (d, i, nodes) => {
      // console.log(nodes[i], d3.select(nodes[i]).attr("original-fill"));
      return d3.select(nodes[i]).attr("original-fill");
    })
    .attr("stroke", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-stroke");
    })
    .style("opacity", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-opacity");
    })
    .attr("r", (d, i, nodes) => {
      return d3.select(nodes[i]).attr("original-radius");
    });

  svg
    .selectAll("circle")
    .classed("muted", true)
    .style("opacity", (d, i, nodes) => {
      return pointOpacityByClass(nodes[i]);
    });

  svg
    .selectAll(`#id${ssjIdValue}`)
    .classed("clicked", true)
    .classed("muted", false);

  d3.selectAll(".clicked")
    .attr("r", (d, i, nodes) => {
      return pointRadiusByClass(nodes[i]);
    })
    .style("opacity", (d, i, nodes) => {
      return pointOpacityByClass(nodes[i]);
    })
    .attr("stroke-width", (d, i, nodes) => {
      return pointStrokeWidthByClass(nodes[i]);
    })
    .raise();
  // Draw connection lines between clicked points
  drawConnectionLines(plotClassName);
};
